type sideType = "top" | "bottom" | "left" | "right";
/**
 * Determines the side on which a popover should be displayed relative to an anchor element.
 * This function helps prevent the popover from being clipped at the bottom of the viewport.
 *
 * @param anchorElement - The HTML element that triggers the popover.
 * @param popoverHeight - The height of the popover element, used to calculate potential clipping.
 * @param edgeSpacing - Optional spacing from the viewport edge (default is 150px).
 * @returns Returns "top" if the popover would be clipped at the bottom given its height, otherwise "bottom".
 */
export const determinePopoverSide = (
  anchorElement: HTMLElement,
  popoverHeight: number,
  edgeSpacing = 150,
): sideType => {
  const rect = anchorElement.getBoundingClientRect();
  return rect.bottom + popoverHeight > window.innerHeight - edgeSpacing
    ? "top"
    : "bottom";
};

// TODO? : Implement left and right popover positioning when needed
